import script from "./PersonalBindingPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalBindingPanel.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalBindingPanel.vue?vue&type=style&index=0&id=5dd1200b&scoped=true&lang=css"

import exportComponent from "../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dd1200b"]])

export default __exports__